module.exports = __webpack_public_path__ + "static/media/checkCheckbox.55d3a86d.svg";